<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoBJ">北京动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>谷城：以严格把关制度力促巡察报告提质</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>为规范巡察报告的撰写、审查、修改、把关程序，近日，谷城县委巡察办制定了《巡察报告起草和审核把关制度》（以下简称《制度》）。</p>

        <p>　《制度》明确了在起草、审查、修改巡察报告中的“六个标准”：即事例客观准确、定性恰当适中、归类规范合理、逻辑清晰严密、建议切实可行、文字简洁明了。</p>

        <p>　《制度》规定了巡察报告审核的“六个环节”：巡察报告须经组务会集中审议、巡察组组长初审、组务会讨论研究、巡察办巡察股复审、巡察办主任办公（扩大）会审核、报送巡察工作领导小组审阅等各环节依次把关，从而确保巡察报告质量。</p>

        <p>《制度》实施以来，得到县委巡察干部的广泛好评。县委第四巡察组组长贺天经表示：“该制度操作性强，不仅提高了巡察报告的撰写质量，而且对在巡察过程中如何查找问题，也起到很好的指导作用。”</p>
         <p>　</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
    GoBJ() {
      this.$router.push("/MakeInspectionTour/BeiJing");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>